export const McqBehaviors = ['single-select', 'multi-select'] as const;

export type McqBehavior = typeof McqBehaviors[number];

export const McqBehaviorLabels: { readonly [K in McqBehavior]: string } = {
  'single-select': 'Single Select',
  'multi-select': 'Multi select'
} as const;

export interface McqChoice {
  readonly label: string;
  readonly selected: boolean;
}

export interface McqModel {
  readonly behavior: McqBehavior;
  readonly choices: readonly McqChoice[];
}

export interface McqSingleSelectState {
  readonly selectedIndex: number | null;
  readonly checked: boolean;
}

export interface McqMultiSelectState {
  readonly states: readonly { selected: boolean, checked: boolean }[]
}

export interface SelectItem {
  readonly type: 'select';
  // correct answer
  readonly choices: readonly SelectChoice[];
}

export interface SelectChoice {
  readonly label: string;
  readonly selected: boolean;
}

export type McqState = McqSingleSelectState | McqMultiSelectState;
